import "./redeemableStoresCanvas.scss";
import { Offcanvas } from "react-bootstrap";
import CloseIcon from "../../../../../../../assets/CloseIcon";
import Typography from "../../../../../../../common/Typography";

const RedeemableStoresCanvas = ({ isOpen, toggleCanvas, applicableStores }) => {
  return (
    <Offcanvas
      scroll={true}
      show={isOpen}
      placement="bottom"
      onHide={toggleCanvas}
      className="redeemable-stores-canvas"
    >
      <Offcanvas.Header>
        <Typography size="display-md" weight="medium">
          Redeemable at {applicableStores?.length} outlets
        </Typography>
        <CloseIcon
          width="20"
          height="20"
          color="#FFFFFF"
          handleClick={toggleCanvas}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        {applicableStores?.map((store, i) => (
          <div className="store-details" key={store?._id ?? store?.id ?? i}>
            {store?.logo?.length > 0 ? (
              <div className="store-logo">
                <img
                  width={52}
                  height={52}
                  src={store?.logo}
                  alt={store?.name}
                />
              </div>
            ) : (
              <div className="store-logo">
                <Typography weight="medium" size="heading-lg">
                  {store.name?.slice(0, 1).toUpperCase()}
                </Typography>
              </div>
            )}
            <Typography weight="medium" size="heading-lg">
              {store.name}
            </Typography>
          </div>
        ))}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default RedeemableStoresCanvas;
